import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomValuesService } from '@core/services/custom-values.service';
import { EDeliverableType } from '@enums/campaign.enum';
import { TranslateModule } from '@ngx-translate/core';
import { CustomRemoveButtonComponent } from '@shared/components/custom-remove-button/custom-remove-button.component';
import { EditableTitleComponent } from '@shared/components/editable-title/editable-title.component';
import { FileUploaderComponent } from '@shared/components/file-uploader/file-uploader.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { MatErrorComponent } from '@shared/components/mat-error/mat-error.component';
import { DeliverableAdvancedButtonComponent } from '../advanced-button/deliverable-advanced-button.component';
import { DeliverableAdvancedSettingsSectionComponent } from '../advanced-settings-section/deliverable-advanced-settings-section.component';
import { ImageDeliverableComponent } from '../shared/image-deliverable/image-deliverable.component';
import { TImageDeliverableConfigOverrides } from '../shared/image-deliverable/image-deliverable.interface';

@Component({
  imports: [
    DeliverableAdvancedButtonComponent,
    DeliverableAdvancedSettingsSectionComponent,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatErrorComponent,
    FileUploaderComponent,
    MatCheckboxModule,
    MatTooltipModule,
    EditableTitleComponent,
    MatExpansionModule,
    IconComponent,
    CustomRemoveButtonComponent,
  ],
  selector: 'app-content',
  templateUrl: '../shared/image-deliverable/image-deliverable.component.html',
})
export class ContentComponent extends ImageDeliverableComponent {
  constructor(customValuesService: CustomValuesService) {
    super(customValuesService);
  }

  protected getConfigOverrides(): TImageDeliverableConfigOverrides {
    return {
      addButtonTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.contentDeliverable.addImage',
      highlightNamespace: 'imageUploader',
      placeholderTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.contentDeliverable.placeholder',
      subtitleTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.contentDeliverable.subtitle',
      type: EDeliverableType.content,
    };
  }
}
